<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <insurance-company-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></insurance-company-form>
  </j-modal>
</template>

<script>

  import InsuranceCompanyForm from './InsuranceCompanyForm'
  export default {
    name: 'InsuranceCompanyModal',
    components: {
      InsuranceCompanyForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add (parentId) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(parentId);
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>